import { render, staticRenderFns } from "./ChooseCity.vue?vue&type=template&id=64671225&scoped=true&"
import script from "./ChooseCity.vue?vue&type=script&lang=js&"
export * from "./ChooseCity.vue?vue&type=script&lang=js&"
import style0 from "./ChooseCity.vue?vue&type=style&index=0&id=64671225&scoped=true&lang=css&"
import style1 from "./ChooseCity.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64671225",
  null
  
)

export default component.exports